import {
  UntypedFormControl,
  ReactiveFormsModule,
  FormsModule,
} from '@angular/forms';
import {
  TENANTS_INFO,
  STAFF_STATE,
  COMPANY_INFO,
  STATSIG_STATE,
  SET_ACTIVE_TENANT,AUTH_STATE,AppState
} from '@fitness-force/state';
import { Store } from '@ngrx/store';
import {
  Observable,
  of,
  BehaviorSubject,
  Subject,
  interval,
  switchMap,
  catchError,
  Subscription,
} from 'rxjs';
import { AsyncPipe, NgClass } from '@angular/common';
import { Component, OnInit, ChangeDetectionStrategy, Renderer2, ChangeDetectorRef, OnDestroy, input, output, inject, viewChild } from '@angular/core';
import type { Client, StaffNotificationResponse, TENANTSINTERFACE, TENANT_MODEL } from '@fitness-force/models';
import { StyleClassModule } from 'primeng/styleclass';
import { SelectModule } from 'primeng/select';
import { ButtonModule } from 'primeng/button';

import { DividerModule } from 'primeng/divider';
import { AvatarModule } from 'primeng/avatar';
import { AutoCompleteModule } from 'primeng/autocomplete';
import {
  ActivatedRoute,
  NavigationEnd,
  Router,
  RouterModule,
} from '@angular/router';
import {
  ClientService,
  OmniSearchService,
  StaffNotificationService,
  TenantService,
  AuthSevices
} from '@fitness-force/api';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

import { DrawerModule } from 'primeng/drawer';
import { ClientInfoSidebarComponent } from '@fitness-force/client-profile-lib';
import { ScrollerModule as VirtualScrollerModule } from 'primeng/scroller';
import { MultiTenantListComponent } from '@fitness-force/common/multi-tenant-list';
import { StaffNotificationSidebarComponent } from '../staff-notification-sidebar/staff-notification-sidebar.component';
import { FeatureFlagService,RouteStateService } from '@fitness-force/shared-utils';
import { ProspectFormComponent } from '@fitness-force/prospect-form-lib';
import { SelectButtonModule } from 'primeng/selectbutton';
import { BillingComponent } from '@fitness-force/billing';
import { ClientOmnisearchComponent } from '@fitness-force/shared';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: true,
  imports: [
    ReactiveFormsModule,
    FormsModule,
    SelectButtonModule,
    StyleClassModule,
    SelectModule,
    ButtonModule,
    AutoCompleteModule,
    DividerModule,
    AvatarModule,
    RouterModule,
    TranslateModule,
    DrawerModule,
    VirtualScrollerModule,
    MultiTenantListComponent,
    ClientInfoSidebarComponent,
    StaffNotificationSidebarComponent,
    ProspectFormComponent,
    BillingComponent,
    ClientOmnisearchComponent,
    AsyncPipe,
    NgClass
]
})
export class HeaderComponent implements OnInit, OnDestroy {
  private readonly store = inject<Store<AppState>>(Store);
  private readonly router = inject(Router);
  private readonly clientService = inject(ClientService);
  private readonly authService = inject(AuthSevices);
  private readonly omniSearchService = inject(OmniSearchService);
  private readonly translate = inject(TranslateService);
  private readonly renderer = inject(Renderer2);
  private readonly activeRoute = inject(ActivatedRoute);
  private readonly tenantService = inject(TenantService);
  private readonly cdr = inject(ChangeDetectorRef);
  private readonly routeStateService = inject(RouteStateService);
  private readonly staffNotification = inject(StaffNotificationService);
  private readonly featureFlagService = inject(FeatureFlagService);

  readonly tenantList = input<TENANTSINTERFACE | any>();
  readonly emittedTenant = output<TENANT_MODEL>();
  readonly emitProspectEvent = output<boolean>();
  readonly taskModified = output<boolean>();
  zoneWiseTenantList: any = [];
  selectedTenant?: TENANT_MODEL;
  searchTenants: UntypedFormControl = new UntypedFormControl('');
  allTenantsControls: UntypedFormControl = new UntypedFormControl('');
  tenantOriginalValue: TENANTSINTERFACE;
  createProspect = new BehaviorSubject<boolean>(false);
  userDetails$ = new BehaviorSubject<any>([]);
  allStaffs$ = new BehaviorSubject([]);
  getAccessTenantList$: Observable<any> | any;
  statsgis$: Observable<any> | any;
  selectedClient: any;
  filteredClient$: BehaviorSubject<Client[]> = new BehaviorSubject(
    [] as Client[]
  );

  currentUserDetails: any;
  showClientSidebar = false;
  activeClientId!: number | null;

  allTenants: any[] = [];
  tenantId: any;
  selectedTenantField: UntypedFormControl = new UntypedFormControl('');
  sidebarMinimized = false;

  readonly autoComplete = viewChild<any>('autoComplete');
  isScrolling: boolean = false;
  pageNumber = 0;
  pageSize: number = 10; // Adjust this value as per your requirement
  query: string = '';

  appConfig = { workspaceAlias: 'unifiedfitnessplatform' };
  olvyUtils: any;
  companyInfoDetail: any;
  public companyInfoDetail$!: Observable<any>;
  private readonly searchText$ = new Subject<string>();
  isGlobal: boolean = false;
  pageNames = [
    { name: 'tenants', url: '/admin/tenant-list' },
    { name: 'create-tenant', url: '/admin/tenant-list/create-tenant' },
    { name: 'company-settings', url: '/company-settings' },
    { name: 'company-settings-detail', url: '/company-settings/company-settings' },
  ];

  showNotificationSidebar: boolean = false;
  private pollingSubscription: Subscription | undefined;
  private authStateSubscription: Subscription | undefined;
  staffNotifications = new BehaviorSubject<StaffNotificationResponse[]>([]);
  showStaffNotificationIcon = new BehaviorSubject<boolean>(false);
  staffNotificationCount = 0;

  showProspect: boolean = false;
  clientId: number = 0;
  formType: string = 'prospect';

  themes = [
    { label: 'Light', value: 'lara-light-blue' },
    { label: 'Dark', value: 'lara-dark-blue' },
    { label: 'Bootstrap Light', value: 'bootstrap4-light-blue' },
    { label: 'Bootstrap Dark', value: 'bootstrap4-dark-blue' }
  ];
  selectedTheme = 'lara-light-blue';

  showPaidFullSidebar:boolean = false;
  planSummarydataObject$ = new BehaviorSubject<any>(null);
  activeTab: string = 'overview';

  private statsigSubscription: Subscription | undefined;
  searchData: { name?: string; email?: string; mobile?: string; };

  private readonly visibilitySubscription: Subscription | undefined;
  private lastPollingTime: number = 0;
  private readonly pollingInterval = 1 * 60 * 1000; // 1 minute in milliseconds
  private isLoggedIn = false;

  constructor() {
    this.handleVisibilityChange = this.handleVisibilityChange.bind(this);
  }

  ngOnInit(): void {
    // Auth before componentInit so isLoggedIn is set when the staff-notification flag triggers polling.
    this.authStateSubscription = this.store.select(AUTH_STATE).subscribe({
      next: (authState: any) => {
        this.isLoggedIn = !!authState.loggedIn;
        if (!authState.loggedIn) {
          this.pollingSubscription?.unsubscribe();
          this.pollingSubscription = undefined;
        } else if (this.showStaffNotificationIcon.getValue()) {
          if (!this.pollingSubscription && !document.hidden) {
            this.startPolling();
          }
        }
      },
    });

    this.componentInit();
    this.routeStateService.closeSidebar$.subscribe({
      next: () => {
        this.showClientSidebar = false;
      },
    });

    // Add visibility change listener
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
  }

  componentInit() {
    this.getAccessTenantList$ = this.store.select(TENANTS_INFO);
    this.statsgis$ = this.store.select(STATSIG_STATE);
    this.companyInfoDetail$ = this.store.select(COMPANY_INFO);
    this.getAccessTenantList$.subscribe((tenant: TENANTSINTERFACE) => {
      if (tenant.selected_tenant.id > 0) {
        this.tenantId = tenant.selected_tenant.id;
        if (!this.selectedTenant)
          // IMPORTANT TO HIDE DROP DOWN..
          this.getGroupData(tenant.accessed_tenant, tenant.selected_tenant);
        this.tenantOriginalValue = tenant;
        this.selectedTenant = tenant.selected_tenant;
        this.allTenants = tenant.accessed_tenant;
        this.cdr.detectChanges();
      }
    });

    // Clean up previous subscription if exists
    this.statsigSubscription?.unsubscribe();
    
    // Assign to statsigSubscription so ngOnDestroy can clean it up
    this.statsigSubscription = this.featureFlagService.getFlag$('show_staff_2way_message_notifciation').subscribe((showStaff2WayMessageNotification) => {
          if(showStaff2WayMessageNotification) {
          this.showStaffNotificationIcon.next(true);
          this.cdr.detectChanges();

          // Only start polling if not already polling
          if (!this.pollingSubscription) {
            this.startPolling();
          }
        } else {
          this.showStaffNotificationIcon.next(false);
          // Stop polling if feature flag is turned off
          this.pollingSubscription?.unsubscribe();
          this.pollingSubscription = undefined;
          this.cdr.detectChanges();
        }
       });

    this.companyInfoDetail$.subscribe((responseData) => {
      if (responseData?.selectedLang?.LANG_CODE) {
        this.translate.setDefaultLang(responseData?.selectedLang?.LANG_CODE);
        this.translate.use(responseData?.selectedLang?.LANG_CODE);
      }

      if (responseData.compDetails != null) {
        this.companyInfoDetail = responseData.compDetails;
      }
    });

    this.activeRoute.queryParams.subscribe({
      next: (queryParms) => {
        // Only sync from URL to state when URL has a different tenant than current selection.
        // Use String comparison since query params are strings.
        const urlTenantId = queryParms.tenant ? String(queryParms.tenant) : null;
        const currentTenantId = this.selectedTenant?.id ? String(this.selectedTenant.id) : null;
        if (urlTenantId && currentTenantId && urlTenantId !== currentTenantId && this.allTenants?.length) {
          const selected_tenant = this.allTenants.find((tenant: any) => String(tenant.id) === urlTenantId);
          if (selected_tenant) {
            this.store.dispatch(SET_ACTIVE_TENANT({ selected_tenant }));
            this.emittedTenant.emit(selected_tenant);
          }
        }
      },
    });

    this.currentUserDetails = this.authService.currentUserDetails();

    if (this.currentUserDetails) {
      this.store.select(STAFF_STATE).subscribe((data: any) => {
        if (data?.staffList && data.staffList.length > 0) {
          const filterDate = data.staffList.filter((o: any) => {
            return o.id === parseInt(this.currentUserDetails.Id);
          });
          if (filterDate) {
            this.userDetails$.next(filterDate[0]);
          }
        }
      });
    }

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        const path = event.url.split('?')[0];
        if (
          this.pageNames.find((page) => page.url === path) ||
          path.startsWith('/company-settings')
        ) {
          this.isGlobal = true;
        } else {
          this.isGlobal = false;
        }
      }
    });
  }

  getNotifications() {
    if (!this.isLoggedIn) {
      return;
    }

    this.staffNotification.getStaffNotifications().subscribe({
      next: (data) => {
        const res = data.items as StaffNotificationResponse[];
        this.staffNotifications.next(res ? res : []);
        this.staffNotificationCount = res ? res.filter((o:any) => o.is_read == false).length : 0;
        this.routeStateService.setStaffNotifications(res ? res : []);
        this.cdr.detectChanges();
      },
      error: (err) => {
        console.error('Polling error:', err);
        this.staffNotifications.next([]);
        this.pollingSubscription?.unsubscribe();
        this.pollingSubscription = undefined;
        this.cdr.detectChanges();
      },
    });
  }

  private handleVisibilityChange(): void {
    // Read current flag value synchronously — avoids creating a new subscription
    // on every tab switch which would cause an ever-growing pile of active subscriptions
    // all firing in parallel whenever the feature flag emits.
    const showStaff2WayMessageNotification = this.showStaffNotificationIcon.getValue();

    if (document.hidden && showStaff2WayMessageNotification) {
      this.pollingSubscription?.unsubscribe();
      this.pollingSubscription = undefined;
      this.lastPollingTime = Date.now();
    } else if (showStaff2WayMessageNotification && this.isLoggedIn) {
      const timeSinceLastPoll = Date.now() - this.lastPollingTime;
      if (timeSinceLastPoll >= this.pollingInterval) {
        this.getNotifications();
      }
      this.startPolling();
    } else {
      this.pollingSubscription?.unsubscribe();
      this.pollingSubscription = undefined;
    }
  }

  startPolling(): void {
    if (this.pollingSubscription || document.hidden || !this.isLoggedIn) {
      return;
    }

    // Make an immediate call first
    this.getNotifications();

    // Then start the interval
    this.pollingSubscription = interval(this.pollingInterval)
      .pipe(
        // Only continue if the page is visible
        switchMap(() => {
          if (document.hidden) {
            return of(null);
          }
          return this.staffNotification.getStaffNotifications();
        }),
        catchError((err) => {
          console.error('Polling error:', err);
          this.pollingSubscription?.unsubscribe();
          this.pollingSubscription = undefined;
          this.cdr.detectChanges();
          return of([]); // Return empty array on error
        })
      )
      .subscribe({
        next: (data) => {
          if (data) {  // Only update if we got actual data (not null from hidden state)
            this.staffNotifications.next(data.items ? data.items : []);
            this.staffNotificationCount = data.items ? data.items.filter((o:any) => o.is_read == false).length : 0;
            this.routeStateService.setStaffNotifications(data.items ? data.items : []);
            this.cdr.detectChanges();
          }
        },
        error: () => {
          this.staffNotifications.next([]);
          this.pollingSubscription?.unsubscribe();
          this.pollingSubscription = undefined;
          this.cdr.detectChanges();
        },
      });
  }

 
  get SelectedTenantField(): UntypedFormControl {
    return this.selectedTenantField as UntypedFormControl;
  }

  selectTenant(event: any) {
    const selected_tenant = event;
    if (this.selectedTenant && selected_tenant.id == this.selectedTenant?.id)
      return;
    // Update route params immediately so URL stays in sync and queryParams subscription won't override
    this.updateRouteWithTenant(selected_tenant.id);
    this.store.dispatch(SET_ACTIVE_TENANT({ selected_tenant }));
    this.tenantService.updateTenantPresaleStatus(selected_tenant);
    this.emittedTenant.emit(selected_tenant);
    const currentUrl = this.router.url;
    if (
      currentUrl === '/tenant-not-found' &&
      selected_tenant.status.toLowerCase() == 'active'
    ) {
      this.router.navigate(['/crm/sales-pipeline']);
    }
    this.store.dispatch({ type: 'ROUTER_GO' });
    this.cdr.detectChanges();
  }

  private updateRouteWithTenant(tenantId: number): void {
    this.router.navigate([], {
      relativeTo: this.activeRoute,
      queryParams: { tenant: tenantId.toString() },
      queryParamsHandling: 'merge',
      replaceUrl: true,
      preserveFragment: true
    }).catch(() => {
      // Navigation can fail if already at same URL; ignore
    });
  }

  get AllTenantsControls(): UntypedFormControl {
    return this.allTenantsControls as UntypedFormControl;
  }

  getGroupData(tenantList: any, selected: any): void {
    /* Filter tenant list zone wise */
    this.zoneWiseTenantList = this.groupByZone(tenantList);

    // Set active tenant value
    // Setting Values ..
    if (!this.SelectedTenantField.value) {
      this.SelectedTenantField.setValue(
        tenantList.find((tenant: any) => tenant.id == selected?.id)
      );
    }
  }

  groupByZone(tenantList: any): { Zone: string; items: any[] }[] {
    const groupedData: { [key: string]: any[] } = {};

    tenantList.forEach((tenant: any) => {
      const zone = tenant.zone;
      if (!groupedData[zone]) {
        groupedData[zone] = [];
      }
      groupedData[zone].push(tenant);
    });

    return Object.keys(groupedData).map((zone) => ({
      Zone: zone,
      items: groupedData[zone],
    }));
  }

  hidePopup(clientId: number) {
    this.createProspect.next(false);
    this.emitProspectEvent.emit(false);
  }

  createProspectEvent(event:any) {
    if (!this.isTenantInActive)
      {
        this.formType = event.formType;
        this.searchData = event.searchData;
        this.createProspect.next(true);
      }
  }

  OpenPopup(formType:string) {
    if (!this.isTenantInActive)
      {
        this.formType = formType;
        this.createProspect.next(true);
      }
  }


  navigateToClientProfile(client: Client) {
    this.activeClientId = client.clt_id;
    this.showClientSidebar = true;
  }

  goToclientProfile(event: any) {
    this.activeClientId = event.clientId;
    this.showClientSidebar = true;
  }

  goToClientProfileDetails(event: any) {
    this.activeClientId = event.clientId;
    this.activeTab = event.tab;
    switch(event.tab){
      case 'pos-addon-charges':
        this.router.navigate(['/pos/pos-addon-charges/', event.clientId]);
        break;
      case 'appointment':
        this.showClientSidebar = true;
        break;
      case 'check-in':
        this.router.navigate(['/client-management/check-in', event.clientId]);
        break;
      case 'transactions':
        this.activeTab = 'transactions';
        this.showClientSidebar = true;
        break;
      case 'subscriptions':
        this.activeTab = 'subscriptions';
        this.showClientSidebar = true;
        break;
      default:
        this.activeTab = 'overview';
        this.showClientSidebar = true;
        break;
    }
    
  }

  addClass(event: Event) {
    const clickedElement = event.target as HTMLElement;
    const classesToAdd = ['fa-spin', 'fa-spinner'];
    classesToAdd.forEach((className) => {
      this.renderer.addClass(clickedElement.firstElementChild, className);
    });
  }

  removeClass(event: Event) {
    const clickedElement = event.target as HTMLElement;
    const classesToAdd = ['fa-spin', 'fa-spinner'];
    classesToAdd.forEach((className) => {
      this.renderer.removeClass(clickedElement.firstElementChild, className);
    });
  }

  taskUpdated(event: boolean) {
    this.taskModified.emit(event);
  }

  CloseSidebar(event: any) {
    this.showClientSidebar = false;
    this.cdr.detectChanges();
  }

  getTenant(client: any) {
    if (client && client.clt_home_club_tenant_id != 0)
      return this.allTenants.find(
        (t: any) => t.id == client.clt_home_club_tenant_id
      );
    else if (client && client.clt_createdin_tenant_id != 0)
      return this.allTenants.find(
        (t: any) => t.id == client.clt_createdin_tenant_id
      );
    else return null;
  }

  get isTenantInActive(): boolean {
    return !!(
      this.selectedTenant &&
      this.selectedTenant.status.toLowerCase() == 'inactive'
    );
  }

  openChangeLog() {
    window.Featurebase('manually_open_changelog_popup');
    // window.open("https://feedback.unifiedfitnessplatform.ai/changelog", "_blank");
  }

  onStaffNotificationIconClick(): void {
    const opening = !this.showNotificationSidebar;
    this.showNotificationSidebar = opening;
    if (opening) {
      this.getNotifications();
    }
    this.cdr.detectChanges();
  }

  closeNotificationSidebar(event: { close: boolean; reloadData: boolean }) {
    if(event.close) this.showNotificationSidebar = false;
    if (event.reloadData) {
      this.getNotifications();
    }
    this.cdr.detectChanges();
  }

  proceedToSignup(event:{proceesToSignup:boolean,Data:any}){
    if(event.proceesToSignup){
      this.planSummarydataObject$.next(event.Data);
      this.showPaidFullSidebar = event.proceesToSignup;
    }
  } 

  hideBillingSummary(event:any){
    this.showPaidFullSidebar = false;
  }

  get SearchTenants() {
    return this.searchTenants.value;
  }

  ngOnDestroy(): void {
    this.pollingSubscription?.unsubscribe();
    this.authStateSubscription?.unsubscribe();
    this.statsigSubscription?.unsubscribe();
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
  }
}
